// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-section.activity-details-panel-container{height:100%}`, "",{"version":3,"sources":["webpack://./src/routes/recent_activity/right_panel/index.scss"],"names":[],"mappings":"AACE,kDACE,WAAA","sourcesContent":[".sidebar-section {\n  &.activity-details-panel-container {\n    height: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
